<template>
    <div id="aboutus" class="section alter">
        <h1 class="header">{{ $t("about-us.header") }}<span class="header-dot">.</span></h1>
        <div class="header-separator"></div>
        <div class="content">
            <div class="alternating-display">
                <div class="flavour-text">
                    <data value="flavour-description">
                        <p>
                            {{ $t("about-us.paragraph.line-1") }}
                            <br>
                            <br>
                            {{ $t("about-us.paragraph.line-2") }}
                            <br>
                            <br>
                            {{ $t("about-us.paragraph.line-3") }}
                            <br>
                            {{ $t("about-us.paragraph.line-4") }}
                            <br>
                            <br>
                            {{ $t("about-us.paragraph.line-5") }}
                        </p>
                    </data>
                </div>
                <div class="displayed-item">
                    <img class="growing-image" src="../../../assets/images/devices/a920main.png" alt="a920main">
                </div>
            </div>
            <div class="logo-row evenly">
                <a href="https://www.mastercard.hr/hr-hr.html" target="_blank">
                    <img class="logo-small" src="../../../assets/images/credit-cards/mastercard.png" alt="">
                </a>
                <a href="https://www.mastercard.hr/hr-hr.html" target="_blank">
                    <img class="logo-small" src="../../../assets/images/credit-cards/maestro.png" alt="">
                </a>
                <a href="https://www.visa.com.hr/" target="_blank">
                    <img class="logo-small" src="../../../assets/images/credit-cards/visa.png" alt="">
                </a>
                <a href="https://www.dinersclub.com/" target="_blank">
                    <img class="logo-small" src="../../../assets/images/credit-cards/diners.png" alt="">
                </a>
                <a href="https://www.unionpayintl.com/en/" target="_blank">
                    <img class="logo-small" src="../../../assets/images/credit-cards/union.png" alt="">
                </a>
                <a href="https://www.global.jcb/en/index.html" target="_blank">
                    <img class="logo-small" src="../../../assets/images/credit-cards/jcb.png" alt="">
                </a>
                <a href="https://play.google.com/">
                    <img class="logo-small" src="../../../assets/images/credit-cards/google-pay-2.png" alt="">
                </a>
                <a href="https://www.apple.com/apple-pay/">
                    <img class="logo-small" src="../../../assets/images/credit-cards/apple-pay.webp" alt="">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

    }
</script>

<style lang="scss" scoped>
    #aboutus {

    }
</style>